import { FC } from 'react';

import { cn } from '@/utils/tailwind';

type OrganizationLogoImageProps = {
  logoUrl: string;
  className?: string;
  alt?: string;
};

export const OrganizationLogoImage: FC<OrganizationLogoImageProps> = ({
  logoUrl,
  className,
  alt = 'Organization logo',
}) => <img src={logoUrl} alt={alt} className={cn('object-contain', className)} />;
